// src/components/VideoPlayer.jsx
import React from "react";
import styles from "./VideoPlayer.module.css";

/**
 * A reusable component to display a YouTube video.
 * It uses the youtubeId from the video data to create an embeddable URL.
 */
function VideoPlayer({ youtubeId }) {
  const embedUrl = `https://www.youtube.com/embed/${youtubeId}`;

  return (
    <div className={styles.videoContainer}>
      <iframe
        className={styles.videoPlayer}
        src={embedUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default VideoPlayer;
